import { useEffect } from 'react';
import { Navbar } from '../components/Navbar';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

export const KontakPage = () => {
  // Set page title
  useEffect(() => {
    document.title = 'Hubungi Kami - Park Serpong | Telepon: 08892273880';
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar scrolled={true} currentPage="kontak" />

      {/* Hero */}
      <section className="relative h-64 md:h-80 flex items-center justify-center overflow-hidden mt-16 md:mt-20">
        <img
          src="/images/beranda/TAHAP 1.jpg"
          alt="Kontak Park Serpong"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-black/70"></div>
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 drop-shadow-2xl">Hubungi Kami</h1>
          <p className="text-lg md:text-xl drop-shadow-lg">Kami siap membantu Anda menemukan rumah impian</p>
        </div>
      </section>

      {/* Contact Info */}
      <section className="py-16 md:py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            {/* Main Contact Cards */}
            <div className="grid md:grid-cols-3 gap-6 mb-12">
              {/* Phone */}
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all text-center">
                <div className="bg-green-100 rounded-full p-4 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                  <Phone size={32} className="text-green-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Telepon</h3>
                <p className="text-gray-600 mb-3">Hubungi kami langsung</p>
                <a href="tel:08892273880" className="text-2xl font-bold text-blue-600 hover:text-blue-700">
                  08892273880
                </a>
              </div>

              {/* Email */}
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all text-center">
                <div className="bg-blue-100 rounded-full p-4 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                  <Mail size={32} className="text-blue-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Email</h3>
                <p className="text-gray-600 mb-3">Kirim pesan via email</p>
                <a href="mailto:info@parkserpong.com" className="text-xl font-bold text-blue-600 hover:text-blue-700 break-all">
                  info@parkserpong.com
                </a>
              </div>

              {/* Location */}
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all text-center">
                <div className="bg-red-100 rounded-full p-4 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                  <MapPin size={32} className="text-red-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Lokasi</h3>
                <p className="text-gray-600 mb-3">Kunjungi sales office</p>
                <p className="text-lg font-semibold text-gray-800">
                  Jl. Raya Legok<br />Tangerang, Banten
                </p>
              </div>
            </div>

            {/* WhatsApp CTA */}
            <div className="bg-gradient-to-r from-green-600 to-green-700 rounded-2xl p-8 md:p-12 text-center text-white shadow-2xl">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">Chat via WhatsApp</h2>
              <p className="text-lg md:text-xl mb-6 opacity-90">
                Dapatkan respon cepat untuk pertanyaan Anda. Tim kami siap membantu!
              </p>
              <a
                href="https://wa.me/628892273880?text=Halo!%20Saya%20ingin%20bertanya%20tentang%20Park%20Serpong.%20Terima%20kasih!"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-white text-green-600 px-8 md:px-12 py-4 md:py-5 rounded-xl text-lg md:text-xl font-bold hover:bg-gray-50 transition-all hover:scale-105 shadow-lg"
              >
                <Phone size={24} />
                <span>Hubungi: 08892273880</span>
              </a>
            </div>

            {/* Office Hours */}
            <div className="mt-12 bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-start gap-4">
                <div className="bg-blue-100 rounded-full p-3">
                  <Clock size={24} className="text-blue-600" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Jam Operasional</h3>
                  <div className="space-y-2 text-gray-700">
                    <p><strong>Senin - Jumat:</strong> 09:00 - 18:00 WIB</p>
                    <p><strong>Sabtu - Minggu:</strong> 09:00 - 17:00 WIB</p>
                    <p className="text-sm text-gray-600 mt-4">* WhatsApp tersedia 24/7</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Access */}
            <div className="mt-12 grid md:grid-cols-2 gap-6">
              <div className="bg-gradient-to-br from-blue-50 to-white rounded-xl p-6 border-2 border-blue-200">
                <h3 className="text-lg font-bold text-gray-900 mb-3">Akses dari Jakarta</h3>
                <p className="text-gray-700">Tol Jakarta-Merak → Exit Serpong/Legok → 10 menit ke Park Serpong</p>
              </div>
              <div className="bg-gradient-to-br from-green-50 to-white rounded-xl p-6 border-2 border-green-200">
                <h3 className="text-lg font-bold text-gray-900 mb-3">Akses dari BSD/Gading</h3>
                <p className="text-gray-700">Jl. Raya Serpong → Jl. Raya Legok → 5-15 menit ke Park Serpong</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};